import request, { ApiResponse } from './request';

export interface Village {
  id: number;
  name: string;
  created_at: string;
}

export function getVillages(): Promise<ApiResponse<Village[]>> {
  return request.get('/villages');
}

export function createVillage(name: string): Promise<ApiResponse<Village>> {
  return request.post('/villages', { name });
}

export function deleteVillage(id: number): Promise<ApiResponse<null>> {
  return request.delete(`/villages/${id}`);
}
